// extracted by mini-css-extract-plugin
export default {"reposition_info_container":"RepositionExtraInfo_reposition_info_container__1zCR6","current":"RepositionExtraInfo_current__0tnPK"};